import { render } from "./OriginalDocumentOrderPage.vue?vue&type=template&id=9f1e5a0c&ts=true"
import script from "./OriginalDocumentOrderPage.ts?vue&type=script&lang=ts&external"
export * from "./OriginalDocumentOrderPage.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__